import * as React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type DropdownOptionProps = {
  children: React.ReactNode
  onClick?: () => void
  selected?: boolean
  url?: string
}

DropdownOption.defaultProps = {
  selected: false,
  url: '',
}

function DropdownOption(props: DropdownOptionProps) {
  const { children, selected, onClick, url } = props

  const className = classNames(style.option, {
    [style.selected]: selected,
  })

  if (url) {
    return (
      <a className={className} href={url}>
        {children}
      </a>
    )
  } else {
    return (
      <button className={className} onClick={onClick}>
        {children}
      </button>
    )
  }
}

type Props = {
  children: React.ReactNode
  className?: string
  isExpanded?: boolean
}

Dropdown.defaultProps = {
  className: '',
  isExpanded: false,
}

function Dropdown(props: Props) {
  const { children, className, isExpanded } = props

  return (
    <nav
      className={classNames(
        style.wrapper,
        { [style.expanded]: isExpanded },
        className,
      )}
    >
      {children}
    </nav>
  )
}

export { DropdownOption, Dropdown }
